<div
    *ngIf="_links?.length > 0"
    class="agpr-linkList"
>
    <a
        *ngIf="state === linkListStateEnum.SHOW_FIRST"
        [id]="id + '.link-0'"
        class="agpr-linkListItem"
        [href]="_links[0].url"
        target="_blank"
        tabindex="-1"
    >
        {{ _links[0].label | localize }}
    </a>
    <agpr-button
        *ngIf="state !== linkListStateEnum.SHOW_FIRST"
        [id]="id + '.toggle'"
        class="agpr-linkListMessage"
        [style]="buttonTypes.link"
        [initiallyFocusable]="false"
        [expanded]="state === linkListStateEnum.SHOW_ALL"
        (click)="toggleList()"
    >
        <span>
            {{ itemsMessage | localize: { 'number': _links.length } }}
        </span> 
        <span
            *ngIf="state === linkListStateEnum.HIDDEN"
            class="agpr-linkListMessageIcon fa-solid fa-angle-down"
            aria-hidden="true"
        ></span>
        <span
            *ngIf="state === linkListStateEnum.SHOW_ALL"
            class="agpr-linkListMessageIcon fa-solid fa-angle-up"
            aria-hidden="true"
        ></span>
    </agpr-button>
    <ul
        *ngIf="state === linkListStateEnum.SHOW_ALL"
        [attr.aria-label]="listAriaLabel | localize"
    >
        <li
            *ngFor="let item of _links; let i = index; let last = last"
            class="agpr-linkListItem"
        >
            <a
                [id]="id + '.link-' + i"
                class="agpr-linkListItem-link"
                [href]="item.url"
                target="_blank"
            >
                <span *ngIf="item.label && item.label.length; else itemUrl">
                    {{ item.label | localize }}
                </span>
                <ng-template #itemUrl>
                    {{ item.url }}
                </ng-template>
            </a>
        </li>
    </ul>
</div>
